var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-position": "top",
                size: "small",
                model: _vm.formParam,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "numberSearch",
                          attrs: {
                            label: _vm.$t("collectionCenter.lanshouOrderNum"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.max2000Line"
                              ),
                              type: "textarea",
                              rows: 4,
                            },
                            model: {
                              value: _vm.formParam.carNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.formParam, "carNumber", $$v)
                              },
                              expression: "formParam.carNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-search",
                              size: "mini",
                            },
                            on: { click: _vm.search },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh", size: "mini" },
                            on: { click: _vm.onReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height - 10,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNumber",
                  label: _vm.$t("collectionCenter.lanshouOrderNum"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsInvoicNo",
                  label: _vm.$t("collectionCenter.commodityInvoiceNumber"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsInvoiceSecretKey",
                  label: _vm.$t("collectionCenter.CommodityInvoiceKey"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsFreightTaker",
                  label: _vm.$t("mdfeTranslate.CargoHandler"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsInvoiceCode",
                  label: _vm.$t("mdfeTranslate.InvoiceCode"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsInvoiceMoney",
                  label: _vm.$t("mdfeTranslate.InvoiceAmount"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceSerialNumber",
                  label: _vm.$t("mdfeTranslate.InvoiceSerialNumber"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceTime",
                  label: _vm.$t("mdfeTranslate.InvoiceTime"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsInvoiceType",
                  label: _vm.$t("collectionCenter.LogisticsInvoiceType"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsInvoiceNo",
                  label: _vm.$t("collectionCenter.logisticsInvoiceNumber"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsInvoiceSecretKey",
                  label: _vm.$t("mdfeTranslate.LogisticsInvoiceKey"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsFreightTaker",
                  label: _vm.$t("mdfeTranslate.LogisticsCargoHandler"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsInvoiceCode",
                  label: _vm.$t("mdfeTranslate.LogisticsInvoiceCode"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsInvoiceMoney",
                  label: _vm.$t("mdfeTranslate.LogisticsInvoiceAmount"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerCpf",
                  label: _vm.$t("mdfeTranslate.BuyerTaxNumber") + " CPF",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerCnpg",
                  label: _vm.$t("mdfeTranslate.BuyerTaxNumber") + " CNPG",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerPhone",
                  label: _vm.$t("mdfeTranslate.BuyerPostalCode"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerState",
                  label:
                    _vm.$t("mdfeTranslate.BuyerAddress") +
                    "-" +
                    _vm.$t("CenterForSorting.state"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerCity",
                  label:
                    _vm.$t("mdfeTranslate.BuyerAddress") +
                    "-" +
                    _vm.$t("collectionCenter.city"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerCityCode",
                  label:
                    _vm.$t("mdfeTranslate.BuyerAddress") +
                    "-" +
                    _vm.$t("collectionCenter.Zip"),
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerArea",
                  label:
                    _vm.$t("mdfeTranslate.BuyerAddress") +
                    "-" +
                    _vm.$t("collectionCenter.Area"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerStreet",
                  label:
                    _vm.$t("mdfeTranslate.BuyerAddress") +
                    "-" +
                    _vm.$t("collectionCenter.RecipientStreet"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerAddress",
                  label: _vm.$t("mdfeTranslate.BuyerDetailedAddress"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerEmail",
                  label: _vm.$t("mdfeTranslate.BuyerEmail"),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerName",
                  label: _vm.$t(
                    "mdfeTranslate.BuyerNameCompanyNameOrPersonalName"
                  ),
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: _vm.$t("collectionCenter.CreationTime"),
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateUserStr",
                  label: _vm.$t("collectionCenter.creator"),
                  "min-width": "180",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTable,
                  "size-change": _vm.getSizeTable,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }